import type React from "react";

export const HANDLE_STYLE = {
  width: 12,
  height: 12,
  borderRadius: 100,
  border: "3px solid var(--sp-handle-border, #C9D5E1)",
  background: "transparent",
} satisfies React.CSSProperties;
